import React, { useEffect, useMemo, useRef, useState } from 'react'

import { DownOutlined } from '@ant-design/icons'
import { App, Button, Card, Empty, Form, Input, Radio, Space, Switch, Tabs, Tree } from 'antd'
import { TextAreaRef } from 'antd/es/input/TextArea'
import type { DataNode } from 'antd/es/tree'
import { orderBy } from 'lodash'
import EditorText from '../../../../Components/EditorText'
import ViewPage from '../../../../Components/ViewPage'
import { Notification } from '../../../../Components/notification'
import { decodeHtml, tryError } from '../../../../services/Afins'
import { getElementos } from '../../../../services/Elementos'
import { useLogic } from '../../../../context/useLogic'
import {
  ItensConfigConsultoriaTypes,
  getConfigBook,
  putConfigBook,
} from '../../../../services/configBook'
import { Container } from './styled'
import { useHistory } from 'react-router'

interface ProsTree extends DataNode {
  ordem: number
  children: {
    key: string
    params: {
      profundidades: {
        [key: string]: { exibe: '0' | '1'; obs: '' }
      }
    }
  }[]
}

const PageConfigConsultoria: React.FC = () => {
  const { message } = App.useApp()
  const refTextArea = useRef<TextAreaRef>(null)

  const { checkSafra } = useLogic()

  const history = useHistory()

  const [configConsultoria, setConfigConsultoria] = useState<ItensConfigConsultoriaTypes>(
    {} as ItensConfigConsultoriaTypes
  )
  const [elementosTree, setElementosTree] = useState<ProsTree[]>([])
  const [selectConfig, setSelectConfig] = useState(1)
  const [textoIntroducao, setTextoIntroducao] = useState('')
  const [editable, setEditable] = useState(false)
  const [elementSelect, setElementSelect] = useState<{ codElemento: string; codDisInt: string }>({
    codDisInt: '',
    codElemento: '',
  })

  const [activeKey, setActiveKey] = useState<string>()
  const [codSelect, setCodSelect] = useState<string[]>([])
  const [keySelectTree, setKeySelectTree] = useState([])
  const [keyExpandedTree, setKeyExpandedTree] = useState([])

  const [form] = Form.useForm()
  const watchObs = Form.useWatch('obs', form)

  const listConfigConsultoria = async () => {
    try {
      message.loading('Carregando...', 9999)
      const resp = await getConfigBook()

      const dados = resp.data.itens[0]

      setConfigConsultoria(dados)

      const textoIntroducao = decodeHtml(dados.mapa_fertilidade.texto_introducao)
      const elementosDefault = await listElementos()

      let mapa: ProsTree[] = []

      for (let i = 0; i < elementosDefault.length; i += 1) {
        const element = elementosDefault[i]
        const mapaFertilidade: ProsTree[] = dados.mapa_fertilidade.elementos.filter((rec) => {
          return Number(rec.key) === element.key
        })
        if (!mapaFertilidade) {
          mapa = [...mapa, ...mapaFertilidade]
        }
      }

      dados.mapa_fertilidade.elementos.push(...mapa)

      setTextoIntroducao(textoIntroducao)

      setElementosTree(orderBy(dados.mapa_fertilidade.elementos, (data) => Number(data.ordem)))
      message.destroy()
    } catch (error) {
      message.destroy()
      tryError(error)
    }
  }

  const listElementos = async (): Promise<ProsTree[]> => {
    const resp = await getElementos({}, 'conta')

    return resp.data.itens.map((res, i) => {
      return {
        title: res.descricao,
        key: res.cod,
        ordem: res.ordem,
        children: [
          {
            key: `${res.cod}_1`,
            title: 'Distribuído',
            params: {
              profundidades: {
                '00-20': { exibe: '1', obs: '' },
                '20-40': { exibe: '1', obs: '' },
                '00-50': { exibe: '1', obs: '' },
                micro: { exibe: '1', obs: '' },
                indicadores: { exibe: '1', obs: '' },
              },
            },
          },
          {
            key: `${res.cod}_2`,
            title: 'Interpretado',
            params: {
              profundidades: {
                '00-20': { exibe: '1', obs: '' },
                '20-40': { exibe: '1', obs: '' },
                '00-50': { exibe: '1', obs: '' },
                micro: { exibe: '1', obs: '' },
                indicadores: { exibe: '1', obs: '' },
              },
            },
          },
        ],
      }
    })
  }

  const handleSelectElementTree = (cod: string[], profundidade) => {
    if (cod.length > 0) {
      setKeyExpandedTree(cod)
      let newCod = ['']
      if (typeof cod[0] !== 'number' && cod[0].split('_').length > 1) {
        newCod = cod
        setKeySelectTree(cod)
      } else {
        newCod = [`${cod[0]}_1`]
        setKeySelectTree(newCod)
      }

      const idElement = newCod[0].split('_')[0]
      const idDisInt = newCod[0].split('_')[1]

      setCodSelect([`${idElement}_${idDisInt}`])

      setElementSelect({ codElemento: idElement, codDisInt: idDisInt })

      const elementos = elementosTree.find((rec) => String(rec.key) === idElement)
      const index = elementosTree.findIndex((rec) => String(rec.key) === idElement)

      if (elementos?.children) {
        const children = elementos.children.find((rec) => rec.key === `${idElement}_${idDisInt}`)

        form.setFieldsValue({
          obs: children.params.profundidades[profundidade]?.obs,
          exibe: children.params.profundidades[profundidade]?.exibe === '1',
          index: index,
          disInt: idDisInt,
        })

        setActiveKey(profundidade)
      }
    } else {
      setKeyExpandedTree([])
    }
  }

  const handleChangeForm = (
    values: {
      obs: string
      exibe: boolean
      index: number
      profundidades: {
        [key: string]: { exibe: '0' | '1'; obs: '' }
      }
      disInt: number
    },
    profundidade
  ) => {
    const dataElemento = [...elementosTree]
    setEditable(true)

    if (dataElemento[values.index]?.children) {
      const indexParams = dataElemento[values.index].children.findIndex(
        (rec) => String(rec.key).split('_')[1] === String(values.disInt)
      )

      const pro = dataElemento[values.index].children[indexParams].params.profundidades
      dataElemento[values.index].children[indexParams].params = {
        profundidades: {
          ...pro,
          [profundidade]: { obs: values.obs, exibe: values.exibe ? '1' : '0' },
        },
      }

      setElementosTree(dataElemento)
    }
  }

  const handleDropElement = (newPosition: number, cod: number) => {
    let ele = [...elementosTree]
    setEditable(true)

    const indexObj = ele.findIndex((rec) => Number(rec.key) === cod)

    if (indexObj >= 0 && indexObj < ele.length && newPosition >= 0 && newPosition < ele.length) {
      const objetoMovido = ele[indexObj]
      ele.splice(indexObj, 1)
      ele.splice(newPosition, 0, objetoMovido)
    }
    ele.map((rec, i) => {
      rec.ordem = i + 1
      return rec
    })
    setElementosTree(ele)
  }

  const handleChangeEditor = (dataEditor, editor = false) => {
    setTextoIntroducao(dataEditor)
    if (editor) {
      setEditable(true)
    }
  }

  const handlePutConfig = async () => {
    try {
      const dados = {
        mapa_fertilidade: { texto_introducao: textoIntroducao, elementos: elementosTree },
      }

      const resp = await putConfigBook(dados)

      if (resp.status === 200) {
        Notification({ message: 'Configurações atualizadas', type: 'success' })
        setEditable(false)
      }
    } catch (error) {
      tryError(error)
    }
  }

  const handleChangeConfig = useMemo(
    () => (value) => {
      setSelectConfig(value)
    },
    [selectConfig]
  )

  useEffect(() => {
    const fetch = async () => {
      listConfigConsultoria()
      // const ele = await listElementos()

      // setElementosTree(ele)
    }

    fetch()
  }, [])

  // useEffect(() => {
  //   const idDaSafra = checkSafra('/precisao/config-book')

  //   if (!idDaSafra) {
  //     history.push('/home')
  //   }
  // }, [])

  return (
    <Container>
      <ViewPage newHide rotina={84} title='Configuração do book'>
        <Card
          extra={
            <Button
              disabled={!editable}
              style={{ marginRight: '25px' }}
              onClick={handlePutConfig}
              type='primary'
            >
              Salvar
            </Button>
          }
          size='small'
          headStyle={{ padding: 0, margin: 0 }}
          bodyStyle={{ height: 'calc(100vh - 210px)' }}
          title={
            <Radio.Group
              style={{ height: '100%' }}
              onChange={(data) => handleChangeConfig(data.target.value)}
              defaultValue={1}
              options={[
                { label: 'Texto introdução', value: 1 },
                { label: 'Elementos', value: 2 },
              ]}
              optionType='button'
              buttonStyle='solid'
            />
          }
        >
          <div hidden={selectConfig !== 1} style={{ height: '100%' }}>
            <EditorText
              data={textoIntroducao}
              onChange={(_, editor) => {
                handleChangeEditor(editor.getData(), true)
              }}
            />
          </div>

          <Space size={[30, 30]} align='start'>
            <div
              style={{
                height: 'calc(100vh - 203px)',
                borderBottom: '1px solid #ccc',
                overflow: 'auto',
                display: selectConfig !== 2 ? 'none' : null,
              }}
            >
              <Tree
                autoExpandParent
                expandedKeys={keyExpandedTree}
                onSelect={(keys, e) => {
                  e.nativeEvent.preventDefault()

                  handleSelectElementTree(keys as string[], '00-20')
                }}
                selectedKeys={keySelectTree}
                onDrop={({ dropPosition, dragNodesKeys }) =>
                  handleDropElement(dropPosition - 1, Number(dragNodesKeys[0]))
                }
                draggable
                treeData={elementosTree}
                showLine
                switcherIcon={<DownOutlined />}
              />
            </div>
            <Form
              hidden={keySelectTree.length <= 0 || selectConfig !== 2}
              form={form}
              onValuesChange={(_, values) => handleChangeForm(values, activeKey)}
              style={{ minWidth: '500px', borderTop: '1px solid #ccc' }}
              layout='vertical'
            >
              <div>
                <h2>
                  {elementosTree[form.getFieldValue('index')]?.title} /{' '}
                  {form.getFieldValue('disInt') === '1' ? 'Distribuído' : 'Interpretado'}
                </h2>
                <Tabs
                  type='card'
                  size='small'
                  tabBarStyle={{ borderRadius: 5 }}
                  onChange={(data) => {
                    handleSelectElementTree(codSelect, data)
                    setActiveKey(data)
                  }}
                  activeKey={activeKey}
                >
                  {[
                    { label: '00-20', value: '00-20' },
                    { label: '20-40', value: '20-40' },
                    { label: '00-50', value: '00-50' },
                    { label: 'micro', value: 'micro' },
                    { label: 'indicadores', value: 'indicadores' },
                    { label: 'prescrições', value: 'prescricoes' },
                  ].map((rec) => (
                    <Tabs.TabPane key={rec.value} tabKey={rec.value} tab={rec.label}>
                      <Space size={25}>
                        <Form.Item
                          style={{ marginTop: 15 }}
                          name='exibe'
                          label='Visível'
                          initialValue={true}
                        >
                          <Switch
                            unCheckedChildren='Não'
                            checked={form.getFieldValue('exibe')}
                            checkedChildren='Sim'
                          />
                        </Form.Item>
                      </Space>
                      <Form.Item
                        name='obs'
                        initialValue=''
                        label='Observação do elemento'
                        extra={
                          <div style={{ color: watchObs?.length > 350 && 'red' }}>{`${
                            watchObs?.length ? watchObs?.length : 0
                          } / 350`}</div>
                        }
                        shouldUpdate={true}
                      >
                        <Input.TextArea maxLength={350} ref={refTextArea} rows={5} />
                      </Form.Item>

                      <Form.Item name='index' hidden />
                      <Form.Item name='disInt' hidden />
                    </Tabs.TabPane>
                  ))}
                </Tabs>
              </div>
            </Form>
            <Empty
              style={{
                minWidth: '30vw',
                minHeight: '50vh',
                display: keySelectTree.length > 0 || selectConfig !== 2 ? 'none' : 'flex',
                justifyContent: 'center',
                flexDirection: 'column',
              }}
              description='Selecione um elemento'
            />
          </Space>
        </Card>
      </ViewPage>
    </Container>
  )
}

export default PageConfigConsultoria